import { Dispatch } from 'redux';
import { Project } from '../../types';
import { ProjectDispatchTypes, SELECT_PROJECT } from './types';

export const selectProject = (project: Project, accessLevel: number) => async (dispatch: Dispatch<ProjectDispatchTypes>) => {
  dispatch({type: SELECT_PROJECT, payload: {project: project, accessLevel: accessLevel}});
}